import React from 'react';
import SearchBar from 'shared/lib/components/controls/search/searchBar';
import { Box, BoxProps } from '@mui/material';
import FullTextCheckbox from 'shared/lib/components/controls/search/fullTextCheckbox';

export default function MiniSearch(props: BoxProps) {
  return (
    <Box
      {...props}
      sx={{
        display: 'flex',
        maxWidth: 1,
        ...props?.sx,
      }}
    >
      <SearchBar
        sx={{ width: 400 }}
        placeholder="Что будем искать?"
      ></SearchBar>
    </Box>
  );
}
